export function postMessage(frame: HTMLIFrameElement, name: string, message?: unknown): boolean {
  const child = frame.contentWindow
  if (!child) return false
  child.postMessage({ source: 'showoff-try-on-client', name, message }, '*')
  return true
}

export function addMessageListener<M = any>(frame: HTMLIFrameElement, name: string, listener: (message: M) => void): () => void {
  const _listener = (event: any) => {
    const { data } = event
    if (data.source === 'showoff-try-on' && data.name === name) {
      const source = frame.contentWindow === event.source
      if (source) listener(data.message)
    }
  }
  window.addEventListener('message', _listener)
  return () => window.removeEventListener('message', _listener)
}
